import { Card } from '@/components/ui/elements/card';

// No skeleton primitive exists in this repo yet -- this mirrors QueueCard's
// real layout footprint (a name line, a meta line, and a badge line on the
// left; a short countdown-shaped block on the right) with plain Tailwind
// animate-pulse blocks, kept self-contained here rather than introducing a
// new shared abstraction for a single caller (QueueList).
export const QueueCardSkeleton = () => (
  <Card
    data-testid="queue-card-skeleton"
    aria-hidden="true"
    className="flex items-start justify-between gap-3"
  >
    <div className="min-w-0 flex-1 space-y-2">
      <div className="h-4 w-32 animate-pulse rounded bg-muted" />
      <div className="h-3 w-24 animate-pulse rounded bg-muted" />
      <div className="h-5 w-28 animate-pulse rounded-full bg-muted" />
    </div>
    <div className="shrink-0">
      <div className="h-4 w-10 animate-pulse rounded bg-muted" />
    </div>
  </Card>
);
